export class LoginChecker {

  constructor () {
    // DO NOTHING
  }

  checkCurrentUserLogin (currentUser) {
    var status = {
      isLogged: false,
      isGoogle: false
    }

    if (!currentUser) {
      // DO NOTHING
    } else {
      status.isLogged = true
      status.isGoogle = this.checkIfGoogle(currentUser)
    }
    return status
  }

  checkIfGoogle(currentUser) {
    var providerData = currentUser.providerData
    var isGoogle = false
    for (var i = 0; i < providerData.length; i++) {
      isGoogle = this.checkProvider(providerData[i])
      if (isGoogle) {

        break;
      }
    }
    return isGoogle && this.checkDomain(currentUser)
  }

  checkProvider (provider) {
    return provider.providerId == 'google.com'
  }

  checkDomain (currentUser) {
    /*
    *
    *
    *  TODO CHECK DOMAIN!!!
    *
    *
    */
    console.warn('THE DOMAIN MUST BE CHECKED!!!')
    return true
  }
}



// WEBPACK FOOTER //
// ./src/utils/login-check.js